export default __webpack_public_path__ + "static/media/editaln5fim.abffd9ef.pdf";